import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const handleNav = (e, path) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <h3>Horizon Recruitment</h3>
            <p>
              Expert construction recruitment across the UK. Building teams that
              build the future since 2015.
            </p>
            <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                style={{ width: '38px', height: '38px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '0.9rem' }}>
                in
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                style={{ width: '38px', height: '38px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '0.9rem' }}>
                X
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                style={{ width: '38px', height: '38px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '0.9rem' }}>
                f
              </a>
            </div>
          </div>

          <div>
            <h3>Quick Links</h3>
            <div className="footer-links">
              <a href="/about" onClick={(e) => handleNav(e, '/about')}>About Us</a>
              <a href="/services" onClick={(e) => handleNav(e, '/services')}>Our Services</a>
              <a href="/sectors" onClick={(e) => handleNav(e, '/sectors')}>Sectors</a>
              <a href="/jobs" onClick={(e) => handleNav(e, '/jobs')}>Browse Jobs</a>
              <a href="/employers" onClick={(e) => handleNav(e, '/employers')}>For Employers</a>
              <a href="/contact" onClick={(e) => handleNav(e, '/contact')}>Contact Us</a>
            </div>
          </div>

          <div>
            <h3>For Job Seekers</h3>
            <div className="footer-links">
              <a href="/jobs" onClick={(e) => handleNav(e, '/jobs')}>Search Jobs</a>
              <a href="/register" onClick={(e) => handleNav(e, '/register')}>Register CV</a>
              <a href="/sectors" onClick={(e) => handleNav(e, '/sectors')}>Industry Sectors</a>
              <a href="/contact" onClick={(e) => handleNav(e, '/contact')}>Career Advice</a>
            </div>
          </div>

          <div>
            <h3>Contact Us</h3>
            <div className="footer-contact-item">
              <span>📍</span>
              <span>United Kingdom</span>
            </div>
            <div className="footer-contact-item">
              <span>✉️</span>
              <span>
                <a href="mailto:info@horizonrecruitmentltd.co.uk" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  info@horizonrecruitmentltd.co.uk
                </a>
              </span>
            </div>
            <div className="footer-contact-item">
              <span>🌐</span>
              <span>horizonrecruitmentltd.co.uk</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {year} Horizon Recruitment Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
